import {ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {isPopulatedString} from '@aviary/store/common/typing.helpers';
import {Environment} from '@environment/environment.type';

@Component({
  selector: 'px-nove-list',
  template: `
    @if (inputsPopulated()) {
      <div [attr.data-novelist-novelistselect]="identifier"></div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class NoveListComponent implements OnInit, OnDestroy {
  @Input({required: true}) public identifier: string;
  @Input({required: true}) public noveListProfile: string;
  @Input({required: true}) public noveListPassword: string;

  private readonly environment = inject(Environment);
  private noveListScript: HTMLElement | null;
  private readonly loadNovelistScriptListener = () => this.queryNovelist();

  ngOnInit(): void {
    if (this.inputsPopulated()) {
      this.loadNoveListScript();
    }
  }

  ngOnDestroy() {
    this.noveListScript?.removeEventListener('load', this.loadNovelistScriptListener);
  }

  public inputsPopulated(): boolean {
    return isPopulatedString(this.identifier) &&
      isPopulatedString(this.noveListProfile) &&
      isPopulatedString(this.noveListPassword);
  }

  public loadNoveListScript(): void {
    if (!this.environment.noveListApiUrl) return;
    const id = 'noveList';
    const body: HTMLElement = document.body;
    this.noveListScript = document.getElementById(id);
    if (this.noveListScript === null) {
      this.noveListScript = document.createElement('script');
      this.noveListScript.setAttribute('id', id);
      this.noveListScript.setAttribute('src', this.environment.noveListApiUrl);
      body.appendChild(this.noveListScript);
      this.noveListScript.addEventListener('load', this.loadNovelistScriptListener, {once: true});
    } else if (window['novSelect']) {
      this.queryNovelist();
    } else {
      this.noveListScript.addEventListener('load', this.loadNovelistScriptListener, {once: true});
    }
  }

  private queryNovelist() {
    const novSelect = window['novSelect'];
    if (!novSelect) {
      throw new Error('Novelist Select failed to load properly');
    }
    novSelect.loadContentForQuery({
        ClientIdentifier: this.identifier,
        ISBN: this.identifier,
        version: '3.0'
      },
      this.noveListProfile,
      this.noveListPassword
    );
  }
}
